!function (e) {
  var t = {};

  function n(r) {
    if (t[r]) return t[r].exports;
    var i = t[r] = {i: r, l: !1, exports: {}};
    return e[r].call(i.exports, i, i.exports, n), i.l = !0, i.exports
  }

  n.m = e, n.c = t, n.d = function (e, t, r) {
    n.o(e, t) || Object.defineProperty(e, t, {enumerable: !0, get: r})
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {value: "Module"}), Object.defineProperty(e, "__esModule", {value: !0})
  }, n.t = function (e, t) {
    if (1 & t && (e = n(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var r = Object.create(null);
    if (n.r(r), Object.defineProperty(r, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var i in e) n.d(r, i, function (t) {
      return e[t]
    }.bind(null, i));
    return r
  }, n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default
    } : function () {
      return e
    };
    return n.d(t, "a", t), t
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t)
  }, n.p = "", n(n.s = 0)
}([function (e, t, n) {
  "use strict";
  n.r(t);
  var r = new (function () {
    function e() {
      var t = this;
      this.setVh = function () {
        try {
          var e = .01 * window.innerHeight;
          document.documentElement.style.setProperty("--vh", e + "px")
        } catch (e) {
          throw document.documentElement.style.removeProperty("--vh"), new Error(e)
        }
      }, this.resizeListener = function () {
        t.setVh()
      }, this.resizeListenerOptimized = e.throttled(300, this.resizeListener), this.orientaionChange = function () {
        setTimeout(t.setVh, 200)
      }
    }

    return e.throttled = function (e, t) {
      var n = 0;
      return function () {
        for (var r = [], i = 0; i < arguments.length; i++) r[i] = arguments[i];
        var o = (new Date).getTime();
        if (!(o - n < e)) return n = o, t.apply(void 0, r)
      }
    }, e
  }());
  t.default = (r.resizeListenerOptimized(), window.addEventListener("resize", r.resizeListenerOptimized), window.addEventListener("scroll", r.resizeListenerOptimized), window.addEventListener("orientationchange", r.orientaionChange), !0)
}]);
